import React from 'react';
import styled from 'styled-components';

function WidgetKeypoint({ article, isKeyPoint }: any) {
  return (
    <WidgetWrapper className='keypoint-flex'>
      <div id='scrollto' className={`keypoint-wrapper ${isKeyPoint ? 'dis' : 'hid'}`}>
        <HiddenHeadSeo
          dangerouslySetInnerHTML={{
            __html: `${article?.blurb || ''}`
          }}
        />
        <div className='keypoint-header'>
          <p>KEY</p>
          <p>POINTS</p>
        </div>
        <div id='keypoint-content' className='keypoint-lists' />
      </div>
    </WidgetWrapper>
  );
}

const HiddenHeadSeo = styled.h2`
  position: absolute;
  visibility: hidden;
  overflow: hidden;
`;

const WidgetWrapper = styled.div`
  .keypoint-wrapper {
    gap: 25px;
    display: flex;
    padding: 30px 0;
    margin-top: 10px;
    border-bottom: 1px dashed #ed1a3b;

    .keypoint-header {
      margin-top: 8px;
      p {
        color: #ed1a3b;
        font-size: 25px;
        font-weight: bolder;
        letter-spacing: 0.4px;
        line-height: 1.05;
        text-transform: uppercase;
      }
    }
    .keypoint-lists::after {
      content: attr(data-text);
      white-space: pre-wrap;
      overflow: hidden;
      max-width: 100%;
      animation: typewriter 4s steps(50) 1s forwards;
    }

    &.hid {
      display: none;
      opacity: 0;
      animation: typewriterReverse 6s steps(100) 0.4s normal both;
    }
    @keyframes typewriter {
      0% {
        max-height: 0;
      }
      20% {
        max-height: 50em;
      }
      100% {
        max-height: 100em;
      }
    }
    @keyframes typewriterReverse {
      100% {
        max-height: 0;
      }
      20% {
        max-height: 50em;
      }
      0% {
        max-height: 100em;
      }
    }

    ul {
      padding-left: 30px;
      line-height: 16px;

      @media (max-width: 767px) {
        padding-left: 15px;
        padding-top: 15px;
      }
      li {
        display: flex;
        align-items: flex-start;

        ::marker {
          font-size: 24px;
          line-height: 0;
          color: #ed1a3b;
        }
        list-style-type: disc;
        display: list-item;
        margin-left: 1.5rem;
        line-height: 1.65;
        font-size: 20px;
        a {
          letter-spacing: 0.2px;
          font-display: swap;
        }
      }
    }

    p {
      margin-left: 1.5rem;
      line-height: 1.65;
      font-size: 20px;
      padding: 5px 0;
    }
    @media (max-width: 767px) {
      display: block;

      padding: 20px 0;
      margin-bottom: 30px;
      .keypoint-header {
        display: flex;
        p {
          font-size: 22px;
        }
        margin-top: 0px;
      }
      ul {
        li {
          font-size: 16px;
        }
      }

      p {
        font-size: 16px;
      }
    }
  }
`;
export default WidgetKeypoint;
